export const policyRulesOptions = [
  {
    label: 'Con Policy Rules aplicadas',
    value: 'true',
  },
  {
    label: 'Sin Policy Rules aplicadas',
    value: 'false',
  },
]
